import api from './api'

// Triage-training endpoints (/triage/*): agentic interview + trainee interview + comparison.
export const triageAPI = {
  getCases: async () => {
    const response = await api.get('/triage/cases')
    return response.data
  },

  agenticRun: async ({ caseId, providers = ['openai'], behaviorConfig = null, maxTurns = 6 }) => {
    const response = await api.post('/triage/agentic-run', {
      case_id: caseId,
      providers,
      behavior_config: behaviorConfig,
      max_turns: maxTurns,
    }, { timeout: 600000 })
    return response.data
  },

  humanStart: async ({ caseId, behaviorConfig = null }) => {
    const response = await api.post('/triage/human-session/start', {
      case_id: caseId,
      behavior_config: behaviorConfig,
    })
    return response.data
  },

  humanReply: async (sessionId, humanUtterance) => {
    const response = await api.post(`/triage/human-session/${sessionId}/patient-reply`, {
      human_utterance: humanUtterance,
    }, { timeout: 120000 })
    return response.data
  },

  humanSubmit: async (sessionId, { assessmentText, providers = ['openai'] }) => {
    const response = await api.post(`/triage/human-session/${sessionId}/submit`, {
      assessment_text: assessmentText,
      providers,
    }, { timeout: 300000 })
    return response.data
  },

  getTaxonomy: async () => {
    const response = await api.get('/triage/taxonomy')
    return response.data
  },
}

export default triageAPI
